// LICENSE_CODE ZON
'use strict';

/*jslint browser:true, es6:true, node:true, react:true*/
import React from 'react';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import hopt from 'hola_opt';
import zmembership from '../../../../svc/account/pub/membership.js';
import zcountry from '/util/country.js';
import { Plus_plan } from './plan.js';
import { Short_plan } from './short_plan';
var get_tip = (plan, best, t) => {
  if (plan.id == 'free') return null;
  var name = t(plan.short_name.toLowerCase().replace(' ', '-'));
  if (plan.id == best.id) return t('best_plan_tip', {
    name
  });
  return t('plan_tip', {
    name
  });
};
var Plus_plans = function Plus_plans(props) {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var plans = props.plans,
    best = props.best,
    set_plan = props.set_plan,
    hola = props.hola,
    N = props.N,
    short = props.short,
    _props$popular = props.popular,
    popular = _props$popular === void 0 ? {} : _props$popular,
    button_title = props.button_title,
    arrow = props.arrow,
    bogof = props.bogof;
  var currency = props.currency || zmembership.get_plan_currency(best, hopt.user_currency);
  var cp = zcountry.currency2prefix(currency);
  var cls = cn('payment-plans payment-plans-' + plans.length, cp.length > 1 && 'payment-plans-cp_wide', props.cls);
  var has_free = plans.findIndex(pl => pl.id == 'free') != -1;
  return /*#__PURE__*/React.createElement("div", {
    className: cls
  }, plans.map(plan => {
    var tip = get_tip(plan, best, t);
    return bogof ? /*#__PURE__*/React.createElement(Short_plan, {
      key: plan.id,
      plan: plan,
      bogof: bogof,
      best: best.id == plan.id,
      on_click: set_plan,
      currency: currency
    }) : /*#__PURE__*/React.createElement(Plus_plan, {
      key: plan.id,
      plan: plan,
      short: short,
      best: best.id == plan.id,
      on_click: set_plan,
      button: N == 2,
      has_free: has_free,
      hola: hola,
      button_title: button_title,
      currency: currency,
      popular: popular.id == plan.id,
      tip: tip,
      arrow: arrow
    });
  }));
};
export { Plus_plans };